import React, {useEffect, useState} from 'react';
import {gql} from 'apollo-boost';
import {Backdrop, Button, CircularProgress, Grid, Paper, Typography,} from '@material-ui/core';
import {navigate} from '@reach/router';
import {Alert} from '@material-ui/lab';
import AddIcon from '@material-ui/icons/Add';
import OfferTable from '../components/Offer/OfferTable';
import useStyles from '../styles/styles';
import getEnvironment from "../utils/getEnvironment";
import useCustomApolloClient from "../apollo/useCustomApolloClient";
import {useLazyQuery, useQuery} from "@apollo/react-hooks";

const Offer = ({advertiserId}) => {
    const classes = useStyles();
    const [success, setSuccess] = useState(false);
    const env = getEnvironment();
    const [filterAdv, setFilterAdv] = useState('');


    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)
    const [refetch, setRefetch] = useState(null)

    const client = useCustomApolloClient()

    const advertiserQuery = gql`
        query AllAdvertisers {
            allAdvertiser {
                id
                companyId
                key
                isTest
                maskedName
                name
            }
        }
    `

    const offerQuery = gql`
        query AllOffer {
            allOffer {
                advertiserId
                offerId
                offerName
                agencyFee
                offerUrls {
                    offerUrlId
                    url
                }
                subOfferIds
            }
        }
    `

    const [getOffers, {loading: offersLoading, error: offersError, data: offersData}] = useLazyQuery(offerQuery, {
        notifyOnNetworkStatusChange: true,
        client: client
    });

    const [getAdvertisers, {loading: advertisersLoading, error: advertisersError, data: advertisersData}] = useLazyQuery(advertiserQuery, {
        notifyOnNetworkStatusChange: true,
    });

    useEffect(() => {
        getOffers();
        getAdvertisers();
    }, [])

    useEffect(() => {
        if(offersData && advertisersData) {
            setLoading(offersLoading || advertisersLoading)
            setError(offersError || advertisersError)
            setData({...offersData, ...advertisersData})
            setRefetch(() => {
                getOffers()
                getAdvertisers()
            })
        }
    }, [offersData, advertisersData])


    useEffect(() => {
        if (advertiserId) {
            setFilterAdv(advertiserId);
        }

    }, [advertiserId]);

    if (loading) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    return (
        <>
            <Typography variant="h2">
                Offers
            </Typography>
            {!loading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
            {data ? (
                <>
                    <Grid container direction="row" justify="space-between" alignItems="center"
                          style={{marginBottom: '15px'}}>
                        <Grid item xs={4}>
                        </Grid>
                        <Grid item xs={4} style={{textAlign: 'right'}}>
                            {env === 'test' ? (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => navigate('/info/offers/add')}
                                    startIcon={<AddIcon/>}>
                                    ADD OFFER
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>
                    <OfferTable
                        data={data}
                        refetch={refetch}
                        setSuccess={setSuccess}
                        filterAdv={filterAdv}
                    />
                </>
            ) : null}
        </>
    )
};

export default Offer;